export default function FilterReducer(currentFilter, action) {
    switch (action.type) {
        case "all": 
        case "completed": 
        case "notCompleted": {
            localStorage.setItem("filteration", action.type);
            return action.type;
        }
        default: {
            throw Error("unexpected filteration:", action.type);
        }
    }
}
